import Service from "../../AuthService";

const WorkScheduleHistory = {
    getWorkScheduleHistory(page) {
        return Service.get("/work_schedule_history?page=" + page);
    },
    showWorkScheduleHistory(id) {
        return Service.get("/work_schedule_history/" + id);
    },
    updateWorkScheduleHistory(id, data) {
        return Service.put("/work_schedule_history/" + id, data);
    },
    createWorkScheduleHistory(data) {
        return Service.post("/work_schedule_history", data);
    },
    deleteWorkScheduleHistory(id) {
        return Service.delete("/work_schedule_history/" + id);
    },
    searchWorkScheduleHistory(data) {
        //console.log(data);
        return Service.post("/work_schedule_history_search", data)
    }
};
export default WorkScheduleHistory;
